/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  GetProgramQueryResponse,
  GetProgramPathParams,
  GetProgram404,
  GetProgram503,
} from '../types/GetProgram.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@eureca/candidate-api-sdk/client';
import type {
  QueryKey,
  QueryClient,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { getProgram } from '../clients/getProgram.ts';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

export const getProgramSuspenseQueryKey = (id: GetProgramPathParams['id']) =>
  [{ url: '/programs/:id', params: { id: id } }] as const;

export type GetProgramSuspenseQueryKey = ReturnType<typeof getProgramSuspenseQueryKey>;

export function getProgramSuspenseQueryOptions(
  id: GetProgramPathParams['id'],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getProgramSuspenseQueryKey(id);
  return queryOptions<
    GetProgramQueryResponse,
    ResponseErrorConfig<GetProgram404 | GetProgram503>,
    GetProgramQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getProgram(id, { ...config, signal: config.signal ?? signal });
    },
  });
}

/**
 * {@link /programs/:id}
 */
export function useGetProgramSuspense<
  TData = GetProgramQueryResponse,
  TQueryKey extends QueryKey = GetProgramSuspenseQueryKey,
>(
  id: GetProgramPathParams['id'],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetProgramQueryResponse,
        ResponseErrorConfig<GetProgram404 | GetProgram503>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getProgramSuspenseQueryKey(id);

  const query = useSuspenseQuery(
    {
      ...getProgramSuspenseQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetProgram404 | GetProgram503>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
